import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  close: <PortalMessage id='t.app.close' defaultMessage='Chiudi' />,
  tabData1: <PortalMessage id='t.app.results.details.tabData1' defaultMessage='Periodo 1' />,
  tabData2: <PortalMessage id='t.app.results.details.tabData2' defaultMessage='Periodo 2' />,
  period: <PortalMessage id='t.app.results.details.period' defaultMessage='Periodo di riferimento:' />,
  transactions: <PortalMessage id='t.app.results.details.transactions' defaultMessage='Transazioni' />,
  transacted: <PortalMessage id='t.app.results.details.transacted' defaultMessage='Transato' />,
  payment: <PortalMessage id='t.app.results.details.payment' defaultMessage='Pagamento' />,
  titleNavigation: <PortalMessage id='t.app.results.details.clients.titleNavigation' defaultMessage='Dettaglio totale clienti' />,
  clientNumber: <PortalMessage id='t.app.results.details.clients.clientsNumber' defaultMessage='Numero clienti' />,
  recurringClients: <PortalMessage id='t.app.results.details.clients.recurringClients' defaultMessage='Clienti ricorrenti' />,
  newClient: <PortalMessage id='t.app.results.details.clients.newClient' defaultMessage='Nuovi clienti' />
}

export default formattedMessage
